(function() {
    'use strict';

a3_cabin_reports.directive('updateConfirm',updateConfirm);
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name updateConfirm
   * @restrict E
   * @description
   *   Implementation of aircraft differences
   *
   *   Display the confirm textto update service workers version
   * @example
   *   Usage:
   *   <update-confirm></update-confirm>
   * @ngInject
   */    
function updateConfirm(SWUpdateService) {
    function link($scope, element, attributes){
        //if serviceWorker registered
        if ($scope.SWRegistration != null) {
            $scope.needUpdate = null;
            $scope.update = update;
            
            //get waiting service worker if exists
            $scope.needUpdate = $scope.SWRegistration.waiting;

            //if waiting service woker exists check how long its been waiting
            if ($scope.needUpdate != null){ 
                SWUpdateService.checkVersionExpiration($scope.SWRegistration);
            }
        }

        function update() {
            SWUpdateService.update($scope.SWRegistration);
        }

    }
    return {
			restrict: 'E',
			terminal: true,
			templateUrl: 'views/directives/updateConfirm.tpl.html',
			scope: true,
            link: link
		}
}
})();